export { View as SignFormCard } from './view'
